import {Button, Col, Form, Row} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {TFormAllValues, TFormKeys} from '../policiesTypes'
import { FormikErrors, FormikTouched } from 'formik'

export const HouseholdInfoTab: React.FC<{
  onPrev: () => void
  onNext: () => void
  handleChange: (field: string, value: any) => void
  handleBlur: (field: TFormKeys) => void
  values: TFormAllValues
  errors: FormikErrors<TFormAllValues>
  touched: FormikTouched<TFormAllValues>
}> = ({onNext, onPrev, handleBlur, handleChange, values, errors, touched}) => {
  const intl = useIntl()
  return (
    <>
      <div className='household-information'>
        <div className='title-section-policy-form'>
          <h6>
            <FormattedMessage
              id='policies.list.wizard.household.title'
              defaultMessage='Household information'
            />
          </h6>
        </div>
        <Row className='address-section-policy-form'>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>
                <FormattedMessage
                  id='policies.list.wizard.household.applicants'
                  defaultMessage='Number of applicants'
                /> <small className='text-danger'>{errors.applicants}</small>
              </Form.Label>
              <Form.Control
                placeholder={intl.formatMessage({
                  id: 'policies.list.wizard.household.applicantsPlaceholder',
                  defaultMessage: 'Enter number of applicants',
                })}
                type='number'
                min='1'
                onChange={(e) => handleChange('applicants', e.target.value)}
                value={values.applicants}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>
                <FormattedMessage
                  id='policies.list.wizard.household.members'
                  defaultMessage='Number of members'
                />
              </Form.Label>
              <Form.Control
                type='number'
                placeholder={intl.formatMessage({
                  id: 'policies.list.wizard.household.membersPlaceholder',
                  defaultMessage: 'Enter number of members',
                })}
                onChange={(e) => handleChange('members', e.target.value)}
                value={values.members}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>
                <FormattedMessage
                  id='policies.list.wizard.household.income'
                  defaultMessage='Estimated household income'
                />
              </Form.Label>
              <Form.Control
                type='text'
                placeholder='0,000'
                // onChange={(e) => handleChange('householdIncome', e.target.value)}
                value={values.holder.annualIncome1}
                onChange={(e) => {
                  const {value} = e.target
                  const noComma = value.replaceAll(',', '')
                  if (noComma !== '' && isNaN(Number(noComma))) return
                  const str = Intl.NumberFormat('en-US').format(Number(noComma))
                  handleChange('holder.annualIncome1', str)
                }}
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
     <div className='btn-prev-next'>
        <Button size='sm' variant='outline' onClick={onPrev} >
          <FormattedMessage id='policies.list.wizard.previous' defaultMessage='PREVIOUS' />
        </Button>
        <Button size='sm' onClick={onNext}>
          <FormattedMessage id='policies.list.wizard.nextStep' defaultMessage='NEXT STEP' />
        </Button>
      </div>
    </>
  )
}
